module.exports = __webpack_public_path__ + "assets/images/project/head/Boram.jpg?v=069cd03f";